export default __webpack_public_path__ + "static/media/googleSignUp.aa0138fe.svg";